var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.text != null && _vm.text != '' && _vm.text.length > 16)?_c('el-tooltip',{staticClass:"item",attrs:{"enterable":"","effect":"dark","content":_vm.text,"placement":"top"}},[_c('el-button',[_vm._v(_vm._s(_vm.text.slice(0, 16) + '...'))])],1):_c('p',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }